import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col, Row } from "reactstrap";
import { TurnOverTitle } from "../../../../Constants/Constants";
import { TurnOverChart } from "../../../../Data/General/Widgets/Chart";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const TurnOver = () => {
  return (
    <Col xl="5" lg="12" className="xl-50">
      <Card>
        <CommonCardHeader title={TurnOverTitle} />
        <CardBody>
          <div className="chart-container">
            <Row>
              <Col sx="12">
                <div id="chart-widget7">
                  <ReactApexChart options={TurnOverChart} series={TurnOverChart.series} type="area" height={320} />
                </div>
              </Col>
            </Row>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TurnOver;
